export enum BulkActionType {
  UPDATE = 'UPDATE',
  SOFT_DELETE = 'SOFT_DELETE',
  DELETE = 'DELETE',
  MOVE = 'MOVE',
}
